import * as _ from "lodash";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {
    WB_PolicyTermTypeRow
} from "../PA.Core/PAdbSchemaRows";
import {PolicyAreaBO} from "./PolicyAreaBO";


export class PolicyAreaBOValidations {

    static async ValidateFields(aBO: PolicyAreaBO): Promise<void> {

        if (_.isEmpty(aBO.WB_PolicyArea.cif.POLICYAREA_NAME)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'Emptyname',
                    type: MessageType.Warning,
                    title: "Policy Area Name cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        }

        if (_.isEmpty(aBO.WB_PolicyArea.cif.BUSINESS_TYPE_OPTIONS)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'Emptyvariables',
                    type: MessageType.Error,
                    title: "Policy Area Business Types cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        }

        if (_.isEmpty(aBO.WB_PolicyArea.cif.RESERVED_TERM_OPTIONS)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'Emptykeyterms',
                    type: MessageType.Error,
                    title: "Policy Area Reserved Terms cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        }

        let filterBackCalcDelta = _.filter(aBO.WB_PolicyArea.WB_PolicyTermTypeRows, (aRow: WB_PolicyTermTypeRow) =>
            aRow.isActive && aRow.cif.INPUT_TYPE == "BackCalculated" && aRow.cif.VALUE_TYPE != "Delta+" && aRow.cif.VALUE_TYPE != "Delta-"
        )
        if(filterBackCalcDelta.length > 0) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'BackCalculatedError',
                    type: MessageType.Error,
                    title: 'Term Type “Back Calculated” can only be assigned to a term with Term Handling “Delta + “ or “Delta - “',
                    description: "",
                    subtitle: "",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('BackCalculatedError')
        }

        let filterBackCalcTime = _.filter(aBO.WB_PolicyArea.WB_PolicyTermTypeRows, (aRow: WB_PolicyTermTypeRow) =>
            aRow.isActive && aRow.cif.INPUT_TYPE == "BackCalculated" && aRow.cif.TIME_MODE != "DesignTime"
        )
        if(filterBackCalcTime.length > 0) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'BackCalculatedTimeModeError',
                    type: MessageType.Error,
                    title: 'Term Type “Back Calculated” can only be assigned to a “Design Time” term',
                    description: "",
                    subtitle: "",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('BackCalculatedTimeModeError')
        }

        let filterCalcBalance = _.filter(aBO.WB_PolicyArea.WB_PolicyTermTypeRows, (aRow: WB_PolicyTermTypeRow) =>
            aRow.isActive && aRow.cif.INPUT_TYPE == "Calculated" && aRow.cif.VALUE_TYPE != "Balance"
        )
        if(filterCalcBalance.length > 0) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'CalculatedError',
                    type: MessageType.Error,
                    title: 'Term Type “Calculated: Sub Total” can only be assigned to a term with Term Handling = “Balance”',
                    description: "",
                    subtitle: "",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('CalculatedError')
        }
    }
}
